import { Component, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import moment from 'moment';
// Components
import { DateTimePickerComponent } from 'shared/components/date-time-picker/date-time-picker.component';
// Directives
import { SimpleDropdownDirective } from 'shared/directives/simple-dropdown.directive';
// Models
import { Employee } from 'shared/models/employee.model';
import { EmployeeService } from 'shared/services/employee.service';
// Services
import { NearMissStepperService } from 'shared/services/near-miss-stepper.service';

@Component({
  selector: 'gw-near-miss-step1',
  templateUrl: './near-miss-step1.component.pug',
  styleUrls: ['./near-miss-step1.component.scss']
})
export class NearMissStep1Component implements OnInit {
  @ViewChild('dateTimeDropdown') dateTimeDropdown: SimpleDropdownDirective;
  @ViewChild('dateTimePicker') dateTimePicker: DateTimePickerComponent;
  employees: Array<Employee>;
  nearMissForm: FormGroup;
  submitted = false;

  constructor(
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private nearMissStepperService: NearMissStepperService,
    private router: Router,
    private employeeService : EmployeeService
  ) { }

  ngOnInit() {
    this.employees = this.route.snapshot.data['employees'];
    this.initForm();
  }

  private initForm(): void {
    const stepData = this.nearMissStepperService.formSteps.step1;
    this.nearMissForm = this.formBuilder.group({
      date: [stepData && stepData.date || '', Validators.required],
      location: [stepData && stepData.location || '', Validators.required],
      reportedBy: [stepData && stepData.reportedBy || this.employeeService.getDefaultEmployee() || '', Validators.required],
      witnesses: [stepData && stepData.witnesses || [], ],
    });
  }

  isFieldInvalid(field: AbstractControl): boolean {
    return !field.valid && this.submitted;
  }

  applyDate(momentDate: moment.Moment): void {
    const date = moment(momentDate).format('YYYY-MM-DD HH:mm'); // ISO format
    this.nearMissForm.controls['date'].setValue(date);
    if (this.dateTimeDropdown) {
      this.dateTimeDropdown.closeDropdown();
    }
  }

  keyDownDateTimePicker(event: KeyboardEvent): void {
    if (this.dateTimePicker) {
      this.dateTimePicker.keydown(event);
    }
  }

  submitForm(form: FormGroup): void {
    this.submitted = true;
    if (form.valid) {
      this.updateStep(form);
      this.goToNextStep();
    }
  }

  setControlValue(data: any, key: string): void {
    this.nearMissForm.controls[key].setValue(data);
  }

  async updateStep(form: FormGroup): Promise<void> {
    this.nearMissStepperService.formSteps.step1 = this.nearMissStepperService.convertStep1FormToObject(form);
    await this.nearMissStepperService.updateInStorage();
  }

  goToNextStep(): void {
    this.router.navigate(['/ehs/near-miss/description'], { replaceUrl: true });
  }
}
